var exports = {
  "a": "Box__5X0PDA",
};

module.exports = exports;
